/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuBars3HIcon16Light } from './UiMenuBars3HIcon16Light';
import { UiMenuBars3HIcon16Regular } from './UiMenuBars3HIcon16Regular';
import { UiMenuBars3HIcon16Solid } from './UiMenuBars3HIcon16Solid';
import { UiMenuBars3HIcon20Light } from './UiMenuBars3HIcon20Light';
import { UiMenuBars3HIcon20Regular } from './UiMenuBars3HIcon20Regular';
import { UiMenuBars3HIcon20Solid } from './UiMenuBars3HIcon20Solid';
import { UiMenuBars3HIcon24Regular } from './UiMenuBars3HIcon24Regular';
import { UiMenuBars3HIcon24Solid } from './UiMenuBars3HIcon24Solid';
import { UiMenuBars3HIcon32Regular } from './UiMenuBars3HIcon32Regular';
import { UiMenuBars3HIcon64Regular } from './UiMenuBars3HIcon64Regular';
var sizes = {
    16: {
        light: UiMenuBars3HIcon16Light,
        regular: UiMenuBars3HIcon16Regular,
        solid: UiMenuBars3HIcon16Solid,
    },
    20: {
        light: UiMenuBars3HIcon20Light,
        regular: UiMenuBars3HIcon20Regular,
        solid: UiMenuBars3HIcon20Solid,
    },
    24: {
        regular: UiMenuBars3HIcon24Regular,
        solid: UiMenuBars3HIcon24Solid,
    },
    32: {
        regular: UiMenuBars3HIcon32Regular,
    },
    64: {
        regular: UiMenuBars3HIcon64Regular,
    },
};
export var UiMenuBars3HIcon = forwardRef('UiMenuBars3HIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
